export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-08_00.9965d4d0.jpg";